import { FaBriefcase, FaCalendarAlt, FaCar, FaCarAlt, FaChalkboardTeacher, FaDollarSign, FaRoad, FaTrophy, FaUsers, FaWallet } from 'react-icons/fa';
import { images } from '../constants'; 

const careerIntro = {
    sub: "Drive Your Career Forward",
    heading: "Accelerate Success with the Automotive Industry",
    description: "At SpeedAuto, we are passionate about delivering exceptional automotive experiences to our customers. We're searching for motivated individuals to join our team and grow in a dynamic environment where innovation and customer satisfaction drive success.",
    points: [
        {
            icon: <FaCar />,
            text: "Cutting-Edge Automotive Technology"
        },
        {
            icon: <FaDollarSign />,
            text: "Attractive Compensation Packages"
        },
        {
            icon: <FaUsers />,
            text: "Collaborative Team Environment"
        },
        {
            icon: <FaBriefcase />,
            text: "Opportunities for Career Growth"
        },
        {
            icon: <FaRoad />,
            text: "Be Part of the Journey"
        }
    ],
}; 

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Sales Executive',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 2 Years in Sales',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$50K - $70K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a Sales Executive! You will be responsible for driving sales, managing client relationships, and providing exceptional customer service. This is a fantastic opportunity to work in a dynamic, fast-paced environment and grow your career in the automotive sales industry.',
        ],
        responsibilities: [
            'Develop and maintain relationships with customers to generate sales.',
            'Achieve sales targets and contribute to business growth.',
            'Negotiate deals and close sales effectively.',
            'Stay up-to-date with automotive products and market trends.',
            'Provide outstanding customer service and post-sales support.',
        ],
        qualifications: [
            'Proven experience in sales, preferably in the automotive industry.',
            'Strong communication and negotiation skills.',
            'Ability to work independently and as part of a team.',
            'Results-driven and goal-oriented mindset.',
            'Proficiency in CRM tools and Microsoft Office.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Service Advisor',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 2 Years in Customer Service or Automotive Industry',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$55K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a Service Advisor! You will be responsible for providing exceptional customer service, coordinating vehicle maintenance and repairs, and ensuring a seamless service experience for clients. This is an excellent opportunity to work in the automotive industry and build strong client relationships.',
        ],
        responsibilities: [
            'Greet customers and assess their vehicle service needs.',
            'Provide accurate cost estimates and timelines for repairs.',
            'Coordinate with the service team to ensure timely completion of work.',
            'Keep customers informed about their vehicle’s status and any additional needs.',
            'Maintain records of service history and customer interactions.',
        ],
        qualifications: [
            'Experience in customer service, preferably in the automotive industry.',
            'Strong communication and problem-solving skills.',
            'Ability to work in a fast-paced environment and manage multiple tasks.',
            'Basic knowledge of vehicle maintenance and repair processes.',
            'Proficiency in CRM software and Microsoft Office tools.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Finance Manager',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 3 Years in Financial Management',
            position: 'Single Position Available',
            days: 'Monday to Friday',
            salary: '$70K - $90K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a Finance Manager! You will be responsible for overseeing financial operations, budgeting, and strategic financial planning. This role offers an exciting opportunity to contribute to the financial success of the company while working in a dynamic automotive environment.',
        ],
        responsibilities: [
            'Manage and oversee financial planning, forecasting, and budgeting.',
            'Analyze financial reports and provide insights for business growth.',
            'Ensure compliance with financial regulations and company policies.',
            'Develop strategies to improve financial performance and cost efficiency.',
            'Collaborate with management to support strategic financial decisions.',
        ],
        qualifications: [
            'Proven experience in financial management, preferably in the automotive industry.',
            'Strong analytical and problem-solving skills.',
            'Proficiency in financial software and reporting tools.',
            'Excellent communication and leadership abilities.',
            'Bachelor’s degree in Finance, Accounting, or a related field.',
        ],
    },
    {
        id: 4,
        image: images.position4,
    
        title: 'Technician',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Shifts, Including Weekends',
            experience: 'Minimum 2 Years in Automotive Repair & Maintenance',
            position: 'Multiple Positions Available',
            days: 'Monday to Saturday',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a skilled Technician! You will be responsible for diagnosing, repairing, and maintaining vehicles to ensure optimal performance and safety. This is a great opportunity to work in a hands-on environment with cutting-edge automotive technology.',
        ],
        responsibilities: [
            'Inspect, diagnose, and repair mechanical and electrical vehicle issues.',
            'Perform routine maintenance, including oil changes, tire rotations, and brake inspections.',
            'Use diagnostic tools to identify and troubleshoot automotive problems.',
            'Ensure all repairs meet safety and performance standards.',
            'Keep work areas clean and organized while following safety protocols.',
        ],
        qualifications: [
            'Proven experience as an automotive technician or mechanic.',
            'Strong knowledge of vehicle diagnostics and repair techniques.',
            'Ability to work with various tools and diagnostic equipment.',
            'Attention to detail and problem-solving skills.',
            'Certification in automotive technology is a plus.',
        ],
    },
    {
        id: 5,
        image: images.position5,
    
        title: 'Marketing Specialist',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 2 Years in Marketing & Branding',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $80K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a Marketing Specialist! In this role, you will create and execute marketing campaigns, enhance brand awareness, and drive customer engagement. This is a great opportunity to bring your creativity and strategic thinking to an exciting automotive environment.',
        ],
        responsibilities: [
            'Develop and implement marketing campaigns across digital and traditional platforms.',
            'Analyze market trends and competitor strategies to optimize marketing efforts.',
            'Manage social media accounts and create engaging content.',
            'Coordinate promotional events, sponsorships, and partnerships.',
            'Monitor campaign performance and adjust strategies based on analytics.',
        ],
        qualifications: [
            'Proven experience in marketing, preferably in the automotive industry.',
            'Strong understanding of digital marketing, SEO, and social media strategies.',
            'Excellent communication and creative thinking skills.',
            'Ability to manage multiple projects and meet deadlines.',
            'Proficiency in marketing tools such as Google Analytics, CRM, and Adobe Creative Suite.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Product Manager',
        details: {
            location: 'SpeedAuto, City',
            timing: 'Full Time',
            hours: 'Standard Business Hours',
            experience: 'Minimum 3 Years in Product Management',
            position: 'Single Position Available',
            days: 'Monday to Friday',
            salary: '$75K - $100K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join SpeedAuto as a Product Manager! In this role, you will oversee the development and lifecycle of automotive products, ensuring they meet market demands and company goals. This is an exciting opportunity to shape the future of SpeedAuto’s product offerings.',
        ],
        responsibilities: [
            'Define and execute product strategies to drive business growth.',
            'Collaborate with cross-functional teams including sales, marketing, and engineering.',
            'Conduct market research to identify customer needs and emerging trends.',
            'Develop product roadmaps and manage product lifecycle.',
            'Ensure product quality and compliance with industry standards.',
        ],
        qualifications: [
            'Proven experience in product management, preferably in the automotive industry.',
            'Strong analytical and problem-solving skills.',
            'Excellent communication and leadership abilities.',
            'Ability to manage multiple projects and meet deadlines.',
            'Proficiency in product management tools and market research techniques.',
        ],
    },

];


const benefits = [
    {
        id: 1,
        title: "Career Advancement",
        description: "At SpeedAuto, we prioritize your professional growth by offering numerous opportunities.",
        icon: <FaTrophy />  // Career Advancement Icon
    },
    {
        id: 2,
        title: "Comprehensive Training",
        description: "We provide training programs to help you master the latest in automotive technology.",
        icon: <FaChalkboardTeacher />  // Training Programs Icon
    },
    {
        id: 3,
        title: "Attractive Compensation",
        description: "We offer competitive salaries, performance-based bonuses, and comprehensive benefits.",
        icon: <FaWallet />  // Attractive Compensation Icon
    },
    {
        id: 4,
        title: "Flexible Scheduling",
        description: "Enjoy a work-life balance with flexible schedules tailored to suit your personal and professional needs.",
        icon: <FaCalendarAlt />  // Flexible Scheduling Icon
    },
    {
        id: 5,
        title: "Team Collaboration",
        description: "Be part of a supportive team culture where innovation and collaboration drive success.",
        icon: <FaUsers />  // Team Collaboration Icon
    },
    {
        id: 6,
        title: "Drive Innovation",
        description: "Make an impact by shaping the future of mobility with cutting-edge automotive solutions.",
        icon: <FaCarAlt />  // Drive Innovation Icon
    },
];


export { positions, benefits, careerIntro };